import React from 'react'
import WinnerProfile from '../../components/winnerProfile/WinnerProfile'
import NavbarMobile from '../../layouts/navabrMobile/NavbarMobile'

const MobWinnerProfile = () => {
  return (
    <div>
        <NavbarMobile />
        <WinnerProfile />
    </div>
  )
}

export default MobWinnerProfile